<template>
  <footer class="footer px-4">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="https://hasher.link" class="font-weight-bold ml-1" target="_blank">Hasher.Link</a>
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <li class="nav-item mr-1">
            <a href="https://xbts.io" title="XBTS DEX"><img class="foot-icon" src="/img/xbts.png"/></a>
          </li>
          <li class="nav-item mr-1">
            <a href="https://smartholdem.io" title="SmartHoldem Platform"><img class="foot-icon" src="/img/sth.png"/></a>
          </li>
          <li class="nav-item mr-1">
            <a href="https://dexgames.net" title="Blockchain DEX Games"><img class="foot-icon" src="/img/dexgames.png"/></a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
  .foot-icon {
    -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);
  }

  .foot-icon:hover {
    -webkit-filter: none; /* Safari 6.0 - 9.0 */
    filter: none;
  }

</style>
